import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { CODES } from "../../consts/codes";
import { GetMasters, ListDownloadMaster } from "../../services/user/masters/mastersService";

/**
 * Slice de Redux para el estado de maestros.
 */
export const mastersSlice = createSlice({
  name: "masters",
  initialState: {
    currentMaster: "2",
    masters: [],
    mastersStatus: "fetch",
    mastersDownload: [],
    mastersDownloadStatus: "fetch",
  },
  reducers: {
    /**
     * @param {Object} state
     * @param {{payload: {current: string}}} action
     */
    setCurrentMaster(state, action) {
      const { current } = action.payload;
      state.currentMaster = current;
    },

    /**
     * @param {Object} state
     * @param {Object} action
     */
    resetMastersStatus(state, action) {
      state.mastersStatus = "fetch";
    },

    /**
     * @param {Object} state
     * @param {Object} action
     */
    resetMastersDownloadStatus(state, action) {
      state.mastersDownloadStatus = "fetch";
    },

    /**
     * @param {Object} state
     * @param {Object} action
     * @returns {string}
     */
    getMaster(state, action) {
      return state.currentMaster;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchMasters.pending, (state, action) => {
        state.mastersStatus = "loading";
      })
      .addCase(fetchMasters.fulfilled, (state, action) => {
        state.mastersStatus = "succeeded";
        state.masters = action.payload;
      })
      .addCase(fetchMasters.rejected, (state, action) => {
        state.mastersStatus = "failed";
        state.masters = [];
      })
      .addCase(fetchMastersDownload.pending, (state, action) => {
        state.mastersDownloadStatus = "loading";
      })
      .addCase(fetchMastersDownload.fulfilled, (state, action) => {
        state.mastersDownloadStatus = "succeeded";
        state.mastersDownload = action.payload;
      })
      .addCase(fetchMastersDownload.rejected, (state, action) => {
        state.mastersDownloadStatus = "failed";
      });
  },
});

/**
 * @param {Object} state
 * @returns {string}
 */
export const getCurrentMaster = (state) => state.masters.currentMaster;

/**
 * @param {Object} state
 * @returns {Array}
 */
export const getMasters = (state) => state.masters.masters;

/**
 * @param {Object} state
 * @returns {string}
 */
export const getMastersStatus = (state) => state.masters.mastersStatus;

/**
 * @param {Object} state
 * @returns {Array}
 */
export const getMastersDownload = (state) => state.masters.mastersDownload;

/**
 * @param {Object} state
 * @returns {string}
 */
export const getMastersDownloadStatus = (state) => state.masters.mastersDownloadStatus;

export const { setCurrentMaster, resetMastersStatus, resetMastersDownloadStatus, getMaster } =
  mastersSlice.actions;

/**
 * @typedef {Object} FetchMastersParams
 * @property {Object} data
 * @property {string} master
 */

/**
 * @type {import("@reduxjs/toolkit").AsyncThunk<*, FetchMastersParams, {}>}
 */
export const fetchMasters = createAsyncThunk(
  "masters/fetchAllMasters",
  async ({ data, master }) => {
    try {
      let requestMasters = undefined;
      //TODO: Ajustar el objeto GetMasters por integracion de grupo empresarial
      switch (master) {
        case "0":
          data["idFileType"] = 14;
          requestMasters = await GetMasters({
            ...data,
          });
          break;
        case "1":
          data["idFileType"] = 13;
          requestMasters = await GetMasters({
            ...data,
          });
          break;
        case "3":
          data["idFileType"] = 40;
          requestMasters = await GetMasters({
            ...data,
          });
          break;
        default:
          break;
      }

      if (requestMasters.status === CODES.COD_RESPONSE_SUCCESS) {
        if (requestMasters.data.responseCode === CODES.COD_RESPONSE_SUCCESS) {
          return requestMasters.data.data;
        }
      }
    } catch (e) {}
  },
);

/**
 * @type {import("@reduxjs/toolkit").AsyncThunk<*, FetchMastersParams, {}>}
 */
export const fetchMastersDownload = createAsyncThunk(
  "masters/fetchAllMastersDownload",
  async ({ data, master }) => {
    let requestMastersDownload = undefined;

    switch (master) {
      case "0":
        data["idFileType"] = 16;
        requestMastersDownload = await ListDownloadMaster({
          ...data,
        });
        break;
      case "1":
        data["idFileType"] = 15;
        requestMastersDownload = await ListDownloadMaster({
          ...data,
        });
        break;
      case "3":
        data["idFileType"] = 39;
        requestMastersDownload = await ListDownloadMaster({
          ...data,
        });
        break;
      default:
        break;
    }
    if (requestMastersDownload.status === CODES.COD_RESPONSE_SUCCESS) {
      if (requestMastersDownload.data.responseCode === CODES.COD_RESPONSE_SUCCESS) {
        return requestMastersDownload.data.data;
      }
    }
  },
);

/** @type {import("@reduxjs/toolkit").Slice["reducer"]} */
export default mastersSlice.reducer;
